import type { IHeaderParams } from 'ag-grid-community';
import type React from 'react';
import { useCallback, useState } from 'react';

import { Button, IconArrowLeft, IconArrowRight } from '../../uikit';

interface IAgCollapsableChildrenHeaderComponent extends IHeaderParams {
    collapseKeys: string[];
    displayNameNode?: React.ReactNode;
}

export const AgCollapsableChildrenHeaderComponent: React.FC<IAgCollapsableChildrenHeaderComponent> = (props) => {
    const { collapseKeys, displayName, api, displayNameNode } = props;
    const [isExpanded, setIsExpanded] = useState(false);

    const onExpandCollapseClick = useCallback(
        (e) => {
            e.stopPropagation();
            e.preventDefault();

            api.setColumnsVisible(collapseKeys, !isExpanded);
            setIsExpanded(!isExpanded);
        },
        [api, collapseKeys, isExpanded],
    );

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {displayNameNode || displayName}
            <Button
                view="clear"
                iconRight={isExpanded ? IconArrowLeft : IconArrowRight}
                onlyIcon
                onClick={onExpandCollapseClick}
                size="xs"
                form="brick"
            />
        </div>
    );
};

AgCollapsableChildrenHeaderComponent.displayName = 'AgCollapsableChildrenHeaderComponent';
